var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m4.913 11.657 25.486 16.005c2.3 1.443 4.942 2.248 7.655 2.33 2.647.08 5.21-.927 7.097-2.785l2.925-2.882 0 0 1.924 1.72-3.041 3.044c-2.302 2.303-5.448 3.561-8.703 3.482-3.337-.082-6.59-1.062-9.416-2.838l-25.313-15.9 0 0 1.386-2.176Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "m15.335 7.948 12.783 7.85 6.402-.09 7.273 6.676 4.761-1.833 1.372 1.118-5.506 5.42-8.69-6.538-4.363.53 0-1.93-.614-.378-5.85-3.6.008 2.317.009 3.155-16.264-10.298 4.46-1.235 4.219-1.164Zm8.867 9.538 3.874 2.385 0 1.366-3.275.4-.588-.365-.011-3.786Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m33.73 18.395 8.09 6.075 4.734-3.92 1.372 1.12-5.506 5.419-8.69-6.538-4.363.53 0-1.93-.277-.172 4.64-.584Zm-9.525.234 1.258.81 1.584-.202 1.029.634-.001 1.367-3.274.398-.588-.364-.008-2.643Zm-14.294-9.183 13 8.352.009 2.848-16.275-10.296 3.266-.904Z",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#639AEB",
    d: "m7.984 0 1.901 1.201-6.46 1.688 2.234 1.806 6.729-1.914.013.008.116 3.928-7.087 1.963-5.43-4.177 2.659-4.43 5.325-.073Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F7D09D",
    points: "24.202 17.486 28.076 19.871 28.076 23.665 24.213 21.272"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F7D09D",
    points: "24.202 17.486 28.076 19.871 28.076 23.665 24.213 21.272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuge);
export default __webpack_public_path__ + "static/media/luge.ce4f938435513cc658602e6ea719eea8.svg";
export { ForwardRef as ReactComponent };